import { FTL_PALLETS_PER_TRUCK } from "freight/constants/cargoPalletConstants";

export const STORAGE_MAX_FTL_PALLETS = FTL_PALLETS_PER_TRUCK;
